module.exports = __webpack_public_path__ + "img/Stars_s.27d85e84.png";